import LLMLogLink from 'app/concierge/panel/active-chat/message/parts/LLMLogLink';

// Chat History grid (Concierge Setup): the chat panel's LLM Log link, without the underline like the grid's other links.
export default function LlmLogCell({ sessionUid }: { sessionUid: string }) {
    return <LLMLogLink sessionUid={sessionUid} underline="none" />;
}
